"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UploadSection =
/*#__PURE__*/
function (_Component) {
  _inherits(UploadSection, _Component);

  function UploadSection(props) {
    var _this;

    _classCallCheck(this, UploadSection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadSection).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "uploadComplete", function () {
      document.getElementById(_this.props.name).value = "";

      _this.setState({
        isUploading: false,
        isFileSelected: false,
        files: []
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFiles", function () {
      return _this.state.files;
    });

    _this.state = {
      isFileSelected: false,
      isUploading: false,
      files: []
    };
    _this.uploadFile = _this.uploadFile.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(UploadSection, [{
    key: "uploadFile",
    value: function uploadFile() {
      this.props.uploadMethod();
      this.setState({
        isUploading: true
      });
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      this.props.cancelMethod();
      this.setState({
        isUploading: false
      });
    }
  }, {
    key: "getFileInfo",
    value: function getFileInfo() {
      return this.state.isFileSelected ? {
        display: 'block'
      } : {
        display: 'none'
      };
    }
  }, {
    key: "selectFile",
    value: function selectFile() {
      var input = document.getElementById(this.props.name);
      input.click();
    }
  }, {
    key: "fileSelected",
    value: function fileSelected() {
      var fileLimit = this.props.fileLimit;
      var inputFiles = document.getElementById(this.props.name).files;
      var selectedFiles = [];

      if (this.props.multiple) {
        selectedFiles = this.state.files;
      }

      for (var i = 0; i < inputFiles.length; i++) {
        selectedFiles.push(inputFiles[i]);
      } // only select files based on file limit


      if (fileLimit) {
        if (selectedFiles.length > fileLimit) {
          alert("You are limited to only uploading " + fileLimit + " files.");
        }

        selectedFiles = selectedFiles.slice(0, fileLimit);
      }

      if (selectedFiles) {
        this.setState({
          isFileSelected: true,
          files: selectedFiles
        });
      }
    }
  }, {
    key: "unSelectFile",
    value: function unSelectFile(file) {
      var files = this.state.files;
      var selected = false; // if single file just remove

      if (files.length == 1) {
        files = [];
        document.getElementById(this.props.name).value = "";
      } else {
        // if there are multiple files only remove selected file
        for (var i = 0; i < files.length; i++) {
          if (files[i] === file) {
            files.splice(i, 1);
          }
        } // check if any files are still selected


        if (files.length > 0) {
          selected = true;
        } else {
          document.getElementById(this.props.name).value = "";
        }
      }

      this.setState({
        isFileSelected: selected,
        files: files
      });
    }
  }, {
    key: "unSelectAllFiles",
    value: function unSelectAllFiles() {
      document.getElementById(this.props.name).value = "";
      this.setState({
        isFileSelected: false,
        files: []
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(files) {
      if (files.length > 0) {
        var fileLimit = this.props.fileLimit;
        var selectedFiles = files;

        if (this.props.multiple) {
          for (var i = 0; i < this.state.files.length; i++) {
            selectedFiles.push(this.state.files[i]);
          }
        }

        if (!this.props.multiple && selectedFiles.length > 1) {
          alert("You are limited to uploading only 1 file.");
          selectedFiles = selectedFiles.slice(0, 1);
        } // only select files based on file limit


        if (fileLimit && this.props.multiple) {
          if (selectedFiles.length > fileLimit) {
            alert("You are limited to only uploading " + fileLimit + " files.");
          }

          selectedFiles = selectedFiles.slice(0, fileLimit);
        }

        this.setState({
          isFileSelected: true,
          files: selectedFiles
        });
      } else {
        alert("File type not accepted.");
      }
    }
  }, {
    key: "getTitleText",
    value: function getTitleText() {
      if (this.props.multiple) {
        return "Drop files here to upload";
      } else {
        return "Drop file here to upload";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: "grid-wrapper"
      }, _react.default.createElement("div", {
        className: this.props.showDownload ? "col-70" : "col-100"
      }, _react.default.createElement("div", {
        className: "file-wrapper-dropzone upload upload-wrapper"
      }, _react.default.createElement(_reactDropzone.default, {
        onDrop: this.onDrop.bind(this),
        className: "dropzone",
        disableClick: true,
        accept: this.props.fileFormats
      }, _react.default.createElement("div", {
        className: !this.state.isUploading ? "" : "hidden"
      }, _react.default.createElement("div", null, !this.props.multiple ? !this.state.isFileSelected ? _react.default.createElement("label", null, this.getTitleText()) : _react.default.createElement("div", null, _react.default.createElement("div", null, this.state.files.map(function (file, index) {
        return _react.default.createElement("div", null, _react.default.createElement("label", {
          key: index
        }, _react.default.createElement("span", null, file.name), _react.default.createElement("span", {
          href: "",
          className: "fa fa-trash clear-bin",
          onClick: function onClick() {
            return _this2.unSelectFile(file);
          }
        })));
      }))) : this.props.groupUploads && this.state.isFileSelected ? _react.default.createElement("label", null, _react.default.createElement("span", null, this.state.files.length, " files"), _react.default.createElement("span", {
        href: "",
        className: "fa fa-trash clear-bin",
        onClick: function onClick() {
          return _this2.unSelectAllFiles();
        }
      })) : _react.default.createElement("label", null, this.getTitleText())), _react.default.createElement("div", {
        className: "button-group"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button-large button-transparent",
        onClick: function onClick() {
          return _this2.selectFile();
        }
      }, "Select file"), _react.default.createElement("input", {
        id: this.props.name,
        type: "file",
        className: "hidden",
        onChange: function onChange() {
          return _this2.fileSelected();
        },
        multiple: this.props.multiple,
        accept: this.props.fileFormats
      }), _react.default.createElement("button", {
        type: "button",
        className: "button-large button-blue",
        disabled: !this.state.isFileSelected,
        onClick: this.uploadFile
      }, "Upload")), this.props.restrictionText ? _react.default.createElement("div", {
        className: "restriction-text"
      }, this.props.restrictionText) : "", this.props.multiple && !this.props.groupUploads ? _react.default.createElement("div", {
        className: "multi-file"
      }, this.state.files.map(function (file, index) {
        return _react.default.createElement("div", null, _react.default.createElement("label", {
          key: index
        }, _react.default.createElement("span", null, file.name), _react.default.createElement("span", {
          href: "",
          className: "fa fa-trash clear-bin",
          onClick: function onClick() {
            return _this2.unSelectFile(file);
          }
        })));
      })) : ""), _react.default.createElement("div", {
        className: this.state.isUploading ? "" : "hidden"
      }, _react.default.createElement("div", null, _react.default.createElement("label", null, "Uploading...")), _react.default.createElement("div", {
        className: "upload-progress"
      }, _react.default.createElement("div", {
        className: "progress-bar"
      })), _react.default.createElement("div", null, _react.default.createElement("a", {
        href: "",
        onClick: function onClick() {
          return _this2.cancelUpload();
        }
      }, "Cancel")))))), _react.default.createElement("div", {
        className: this.props.showDownload ? "col-30" : "hidden"
      }, _react.default.createElement("div", {
        className: "file-wrapper download upload-wrapper"
      }, _react.default.createElement("div", null, _react.default.createElement("label", null, this.props.downloadTitle)), _react.default.createElement("div", {
        className: "button-group"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button-large button-transparent",
        onClick: function onClick() {
          return _this2.props.downloadMethod();
        }
      }, "Download")), this.props.downloadText ? _react.default.createElement("div", {
        className: "restriction-text"
      }, this.props.downloadText) : "")));
    }
  }]);

  return UploadSection;
}(_react.Component);

var _default = UploadSection;
exports.default = _default;